import React from 'react';
import MetricaBase from './MetricaBase';

const MetricaDependentes = () => {
  return (
    <MetricaBase
      titulo="Colaboradores com Dependentes"
      descricao="Análise de colaboradores ativos com e sem dependentes"
      endpoint="dependentes"
      tipoDownload="dependentes"
      cor="teal"
      mostrarGraficoArea={false}
    />
  );
};

export default MetricaDependentes;